import config from "config";
import { Main } from "screens/main";
import { MapConfig } from "shared/config";
import { FireBaseService } from "shared/services";
import { LanguageStorage } from "shared/storages";

export class UserService {
    public static createUser(user) {
        return FireBaseService.firestore.collection('users').add(user)
    }

    public static changeUserScoreInLevel(currentLevel: string, score: number) {        
        const user = JSON.parse(localStorage.getItem('mbny_game_user'));
        const userLevels = user.levels;
        const userId = user.id;
        
        for (const key in userLevels) {            
            if (userLevels.hasOwnProperty(key) && Number.parseInt(key) === Number.parseInt(currentLevel)) {
                
                const element = userLevels[key];
                element.score = score;
                
            }
        }

        
        if (config.guest) {
            // return FireBaseService.firestore.collection('users').doc(userId).set(user);  
            localStorage.setItem('mbny_game_user', JSON.stringify(user));

        } else {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", `Bearer ${config.token}`);
            const requestOptions2 = {
                method: 'PUT',
                // headers: myHeaders,
                credentials: 'include',                
            };
            //@ts-ignore
            fetch(`${config.path}/match-game/level?userId=${config.playerId}&level=${currentLevel}&score=${score}&time=${user.levels[currentLevel].time}&isRevard=true`, requestOptions2)
                .then(response => response.json())
                .then(result => {
                    console.log(result);
                    localStorage.setItem('mbny_game_user', JSON.stringify(user));
                })
                .catch(error => console.log('error', error));
        }        
    }

    public static changeUserId(id: string) {
        return FireBaseService.firestore.collection('users').doc(id).set({
            id: id
        });
    }

    public static getUserByMblnId(id): any {
        return FireBaseService.getCurrentUser(id);
    }

    public static async saveNickName(name: string) {
        const data = JSON.stringify({
            userId: config.playerId,
            nickname: name
        });

        const requestOptions = {
            method: 'PUT',
            redirect: 'follow',
            credentials: 'include',
            headers: {
                ContentType: 'application/json;charset=utf-8',
                // Authorization: `Bearer ${config.token}`,
            },
            // body: data
        };
        //@ts-ignore
        // await fetch(`${config.path}/match-game/nickname`, requestOptions)
        await fetch(`${config.path}/match-game/nickname?userId=${config.playerId}&nickname=${name}`, requestOptions)
            .then(response => response.text())
            .then(result => console.log(result))
            .catch(error => console.log('error', error));
    }

    public static async getUserData() {

        if (config.debugMode) {

            const testData = {
                status: "200",
                message: "Success",
                playerData: {
                    id: "25eca36c-4c35-4095-8d8c-ce17b4550dfe",
                    nickname: "anacb",
                    score: 250,
                    level: 2,
                    levels: [
                        {
                            levelId: "811cb5ff-e682-45f2-a7c1-e5ccb5dd3f62",
                            userId: "25eca36c-4c35-4095-8d8c-ce17b4550dfe",
                            score: 100,
                            time: 180,
                            level: 1,
                            isRevard: true
                        },
                        {
                            levelId: "6530b012-0038-46b4-976b-dc62993973ea",
                            userId: "25eca36c-4c35-4095-8d8c-ce17b4550dfe",
                            score: 150,
                            time: 250,
                            level: 2,
                            isRevard: true
                        }
                    ],
                    tutorials: {
                        background_release: false,
                        fill_bar: false,
                        drop_product: false
                    }
                }
            }

            config.tutorials = testData.playerData.tutorials;
            config.level = testData.playerData.level;
            config.nickname = testData.playerData.nickname;
            config.score = testData.playerData.score;

            const user = {
                userName: config.nickname,
                revards: [],
                score: config.score,
                id: testData.playerData.id,
                language: 'en',
                level: testData.playerData.level,
                tutorails: {
                    background_release: false,
                    fill_bar: false,
                    drop_product: false,
                },
                levels: testData.playerData.levels,
                isMusicOn: true,
            }
            localStorage.setItem('mbny_game_user', JSON.stringify(user));

            // config.tutorials = {
            //     background_release: false,
            //     fill_bar: false,
            //     drop_product: false,
            // };
            // config.level = 1;
            // config.nickname = '';
            // config.score = 0;
        } else {
            // const myHeaders = new Headers();
            // myHeaders.append("Authorization", `Bearer ${config.token}`);
            // myHeaders.append("Cookie", ".ASPXAUTH=E9DA9C13C33737ABF830ED77570064C1308550AD7E08E1BF15D19B8F358D21841390FF6BEEFC6DF8AE84FD8D917D2700F81F9812F13318CD189F1697C4681CC0BC4C3A9C304F699FF3E0EA0E44D92EAE71C01B8172ABF6126AE404922B358508F212408DACFEECDF45529D5B3BC4BB2425BE15DD92CC03E919BA56F4443A4A1DDD73F62423FD106411CBAE00572841D6C6BFCBBCC2E66CD15B9A44F56F73E35446DB0AD6; ASP.NET_SessionId=dg1xim41v5whmzv3abdqy1qo; SCAuth=4CC7FA71A96A1945984F0C50DE5C2EBA19676F16DD2B9B79631F80927BF8D54E41E54F427EC15B53ED75D249B504F40CF777E432D68C12A2EFAB9DEB7D8680FA5BE7AB36C5D4A6CCBBDEA0D31B84B2A2030C9D5FAF521423971F5DFBFAB7268D281A607B2FFE657FE1CAB6260233BACB3BBA54DDC0B265871836A1CF290D83A414A90F2BE7E53327D03E1F3E7A8ABCBAE9D294A8E293FDEA0866EF801EA795ED456422B0669E1F38D29659A9290FA2DAE76A885E5C1C5475EF3AEE5430A3A69442D62F6629DF501480B0D4226F3CC4D6008273BB; SC_ANALYTICS_GLOBAL_COOKIE=0d61d83a0a89495f8fdb9e2cc43b4df0|False; UserAuthentication=authenticated=yes&user_id=25eca36c-4c35-4095-8d8c-ce17b4550dfe&last_user_id=25eca36c-4c35-4095-8d8c-ce17b4550dfe&lg_key=73f4882d-7ff2-4d98-8cd7-b05f6ffc90db&geoIP=none; cookiesession1=678A3E0D898901234BCDEFGHIJKL234F; reinfo=0; sc_expview=0");

            const requestOptions = {
                method: 'GET',
                redirect: 'follow',
                credentials: 'include',
                headers: {
                    ContentType: 'application/json;charset=utf-8',
                    // Authorization: `Bearer ${config.token}`,
                },
            };
            //@ts-ignore
            await fetch(`${config.path}/match-game/player?userId=${config.playerId}`, requestOptions)
                .then(response => response.json())
                .then((result: any) => {
                    console.log(result);
    
                    config.tutorials = result.playerData.tutorials;
                    config.level = result.playerData.level;
                    config.nickname = result.playerData.nickname;
                    config.score = result.playerData.score;                    

                    const user = {
                        userName: config.nickname,
                        revards: [],
                        score: config.score,
                        id: result.playerData.id,
                        language: 'en',
                        level: result.playerData.level,
                        tutorails: {
                            background_release: false,
                            fill_bar: false,
                            drop_product: false,
                        },
                        levels: {},
                        isMusicOn: true,
                    }

                    const levelsData = result.playerData.levels;
                    const levels = MapConfig.elements;
                    for (let i = 0; i < levels.length; i++) {
                        const level = levels[i];
                        const data = {
                            score: 0,
                            time: 0,
                            level: level.level,
                            isRevard: level.isRevard,
                        }
                        // user.levels.push(data)
                        user.levels[level.level] = data;
                    }

                    if(levelsData.length > 0) {
                    // if(Object.keys(levelsData).length > 0) {
                        for (let i = 0; i < levelsData.length; i++) {
                            const el = levelsData[i]; 
                            if(i !== 0){
                                if (levelsData[i].level !== levelsData[i-1].level) user.levels[el.level] = el;
                            } else user.levels[el.level] = el;
                            // if(i !== 0){
                            //     if (levelsData[i].level !== levelsData[i-1].level) user.levels.splice(levelsData[i].level - 1, 1, levelsData[i]);
                            // } else user.levels.splice(i, 1, levelsData[i]);
                        }
                    }
                    localStorage.setItem('mbny_game_user', JSON.stringify(user));
                })
                .catch(error => {
                    console.log('error', error);
                });                
         

            
            // Polina test works 
            // var myHeaders = new Headers();
            // myHeaders.append("Authorization", "Bearer dhP2WZ+kKEaYahJT6nK5AQ==");

            // var requestOptions2 = {
            //     method: 'PUT',
            //     headers: myHeaders,
            //     redirect: 'follow'
            // };
            // //@ts-ignore
            // fetch("https://staging-na-us.maybelline.com/match-game/level?userId=8fee5034-2c15-4c09-9990-980fb0f02905&level=1&score=1500&time=45&isRevard=true", requestOptions2)
            //     .then(response => response.text())
            //     .then(result => console.log(result))
            //     .catch(error => console.log('error', error));
        }

        
    }
}